import {getUserInfoAPI, getProductsAPI,getCircleAPI,
    getPicturesAPI, getProductListAPI} from './apis'
import * as ActionTypes from './ActionTypes'

import {getUnionIdByCodeAPI, loginByWxUnionIdAPI} from '../../apis/weixin';

function getQuery(key, def = null) {
    const res = document.location.href.match(new RegExp(key + '=([^&#]+)'));
    return res ? res[1] : def;
}


export const loginByWxUnionId = () => {
    return async (dispatch) => {

        let unionId = localStorage.unionId;
        console.log(document.location.href+'-->href')
        if (!unionId) {
            const code = getQuery('code');

            const res = await getUnionIdByCodeAPI(code);
            if (res.isOk) {
                unionId = res.data.data.unionid;
                localStorage.unionId = unionId;
            } else
                return res;
        }

        global.unionId = unionId;
        const res = await loginByWxUnionIdAPI(unionId);

        if (res.isOk) {
            dispatch({type: ActionTypes.LOGIN, info: res.data.data});
        }
        return res;
    }
};

export const getUserInfo = (userId) => {
    return async (dispatch) => {
        const res = await getUserInfoAPI(userId);

        if (res.isOk) {
            await dispatch({
                type: ActionTypes.INIT_USER,
                user: res.data.data
            })
        }

        return res
    }
};

export const getProducts = (tag, loadMore) => {
    return async (dispatch, state) => {
        const {app} = state();

        let index = 0;

        if (loadMore && app.list.length) {

            if (!app.loadMore)
                return
            index = app.list.length
        }

        const res = await getProductsAPI(app.userInfo.userId, index, tag);

        if (res.isOk && res.data.data && res.data.data.list && res.data.data.list.length) {
            await dispatch({
                type: ActionTypes.INIT_PRODUCTS,
                data: {
                    list: loadMore ? app.list.concat(res.data.data.list) : res.data.data.list,
                    tagList: (loadMore || tag) ? app.tagList : res.data.data.tagList,
                    loadMore: res.data.loadMore
                }
            })
        }

        return res
    }
};

export const getProductListByTag = (userId, tag, loadMore) => {
    return async (dispatch, state) => {
        const {app} = state();

        const res = await getProductListAPI({userId, tag, index: loadMore ? app.productList.length : 0, limit: 20});
        if (res.isOk && res.data.data && res.data.data.list && res.data.data.list.length) {
            await dispatch({
                type: ActionTypes.INIT_PRODUCT_LIST_BY_TAG,
                data: {
                    productList: loadMore ? app.productList.concat(res.data.data.list) : res.data.data.list,
                    loadMore: res.data.loadMore
                }
            })
        }

        return res
    }
};

export const getCirclesAPI = (loadMore) => {

        return async (dispatch, state) => {
            const {app} = state();

            let time = null;

            if (loadMore && app.circleList.length) {

                if (!app.loadMore)
                    return
                time = app.circleList[app.circleList.length - 1].created
            }

            const res = await getCircleAPI(app.userInfo.userId, time);

            if (res.isOk && res.data.data && res.data.data.length) {
                await dispatch({
                    type: ActionTypes.INIT_CIRCLE,
                    data: {
                        circleList: loadMore ? app.circleList.concat(res.data.data) : res.data.data,
                        loadMore: res.data.loadMore
                    }
                })
            }

            return res
        }
};

export const getPictures = (loadMore) => {
    return async (dispatch, state) => {
        const {app} = state();

        let index = null;

        if (loadMore && app.piclist.length) {

            if (!app.loadMore)
                return
            index = app.piclist.length
        }

        const res = await getPicturesAPI(app.userInfo.userId, index);

        if (res.isOk && res.data.data.list && res.data.data.list.length) {
            await dispatch({
                type: ActionTypes.INIT_PICTURE,
                data: {
                    piclist: loadMore ? app.piclist.concat(res.data.data.list) : res.data.data.list,
                    loadMore: res.data.loadMore
                }
            })
        }

        return res
    }
};


// export const getUsersPictureSetAPI = (ownerId, index = 0) => {
//     return getMoreList('/new/users/pictureSet/list', {ownerId, index}, 10);
// };


// export const getOutboxAPI = async (params) => {
//     const limit = 5;
//     return await  getMoreList('/new/outbox', params, limit);
// };



// WEBPACK FOOTER //
// ./src/apps/portfolio/actions.js